var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "53px",
    viewBox: "0 0 29 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow/right",
    transform: "translate(-12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.091307,25.6554246 C39.989747,24.6281246 39.575687,23.6554246 38.903807,22.8742246 L20.903807,1.87422462 C20.056147,0.815624616 18.817907,0.147624616 17.470207,0.0226246158 C16.118607,-0.106285384 14.778807,0.319494616 13.747507,1.20232462 C12.720207,2.08123462 12.091307,3.34292462 12.009207,4.69452462 C11.927176,6.04612462 12.395927,7.37422462 13.310007,8.37422462 L28.529007,26.1242246 L13.310007,43.8742246 C12.395947,44.8742246 11.927207,46.2023246 12.009207,47.5539246 C12.091238,48.9055246 12.720147,50.1633246 13.747507,51.0461246 C14.778707,51.9250346 16.118607,52.3508246 17.470207,52.2258246 C18.817907,52.0969146 20.056107,51.4289546 20.903807,50.3742246 L38.903807,29.3742246 C39.786617,28.3469246 40.216307,27.0031246 40.091307,25.6554246 L40.091307,25.6554246 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default ForwardRef;